import { SvgIcon } from "@material-ui/core";
import React from "react";

export const CartIcon = (props) => {
	return (
		<SvgIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
				<rect width="256" height="256" fill="none" />
				<path
					d="M20,32H40L76.75,164.28A16,16,0,0,0,92.16,176H191a16,16,0,0,0,15.42-11.72L232,72H51.11"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="24"
				/>
				<circle cx="88" cy="220" r="20" />
				<circle cx="192" cy="220" r="20" />
			</svg>
		</SvgIcon>
	);
};
